const React = require('react')
const Layout = require('./src/layout/layout').default

exports.wrapPageElement = ({ element, props }: any) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>
}
